import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { CONTRACT_ADDRESS, TOKEN_TICKER } from "../data/mock";

const ContractAddress = ({ className = "" }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CONTRACT_ADDRESS);
    } catch (e) {
      const ta = document.createElement("textarea");
      ta.value = CONTRACT_ADDRESS;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div
      data-testid="contract-address"
      className={`flex items-center gap-2 sm:gap-3 min-w-0 max-w-full ${className}`}
    >
      <span className="pixel-font text-[#ffcb05] text-[10px] sm:text-xs shrink-0">
        {TOKEN_TICKER}
      </span>
      <button
        onClick={copy}
        title="Copy contract address"
        aria-label="Copy contract address"
        data-testid="contract-address-copy"
        className="group flex items-center gap-2 min-w-0 rounded-md border border-[#ffcb05]/30 bg-[#ffcb05]/5 hover:bg-[#ffcb05]/10 px-2.5 sm:px-3 py-1.5 transition-colors"
      >
        <span
          className="mono-pixel text-white/80 truncate"
          style={{ fontSize: 15 }}
          data-testid="contract-address-value"
        >
          {CONTRACT_ADDRESS}
        </span>
        {copied ? (
          <Check size={14} className="text-green-400 shrink-0" />
        ) : (
          <Copy size={14} className="text-[#ffcb05] shrink-0 group-hover:scale-110 transition-transform" />
        )}
      </button>
      {copied && (
        <span className="mono-pixel text-green-400 shrink-0 hidden sm:inline" style={{ fontSize: 14 }}>
          copied!
        </span>
      )}
    </div>
  );
};

export default ContractAddress;
